import { Search, PenTool, Rocket, TrendingUp } from "lucide-react";

const STEPS = [
  {
    icon: Search,
    title: "Website Review",
    desc: "I look at your current website, branding, and business goals — and write down exactly what&apos;s working and what isn&apos;t.",
  },
  {
    icon: PenTool,
    title: "Custom Concept",
    desc: "I create a clean redesign or landing page concept built around your business and the customers you actually want.",
  },
  {
    icon: Rocket,
    title: "Build & Launch",
    desc: "Once approved, the site is finalized, optimized for mobile, and prepared for launch — fast, no drama.",
  },
  {
    icon: TrendingUp,
    title: "Improve & Grow",
    desc: "We keep improving with reviews, forms, FAQs, booking systems, and lead capture so the site keeps producing results.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="text-xs tracking-[0.22em] uppercase text-blue-400 font-medium">
            Process
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mt-4 leading-[1.1]">
            How it <span className="italic">works</span>.
          </h2>
          <p className="mt-5 text-white/55 max-w-2xl text-sm md:text-base">
            A simple, direct process. No bloated agency theatre — just four
            steps from where you are to a website that actually helps your
            business grow.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* connector line */}
          <div className="hidden lg:block absolute top-12 left-12 right-12 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {STEPS.map((s, idx) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.title}
                  data-testid={`process-step-${idx + 1}`}
                  className="relative card-soft rounded-2xl p-7 md:p-8"
                >
                  <div className="flex items-center justify-between">
                    <div className="h-12 w-12 rounded-xl flex items-center justify-center border border-white/10 bg-white/[0.03] text-blue-300">
                      <Icon size={20} />
                    </div>
                    <span className="font-display italic text-5xl text-white/10">
                      0{idx + 1}
                    </span>
                  </div>
                  <h3 className="font-display text-xl md:text-2xl mt-6 text-white">
                    {s.title}
                  </h3>
                  <p
                    className="mt-3 text-sm text-white/55 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: s.desc }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
